<div
  [formGroup]="parentForm"
  class="autocomplete-container"
  [class.ms-xlarge-b]="displayMargin"
  [class.theme-web2]="theme === DatepickerTheme.WEB_2"
  matAutocompleteOrigin
  #origin="matAutocompleteOrigin"
>
  <div class="relative ps-xxsmall-b" [class.new-theme]="theme === DatepickerTheme.WEB_2">
    <label
      class="flex ps-xxsmall-b font-body-medium text-icon-secondary"
      [for]="idOrControlName"
      [ngClass]="{
        'grey-600-text': !(ctrlField.invalid && ctrlField.touched) && theme === DatepickerTheme.DEFAULT,
        'nordic-blue-400-text': !(ctrlField.invalid && ctrlField.touched) && theme === DatepickerTheme.WEB_2,
        'error-900-text': ctrlField.invalid && ctrlField.touched,
      }"
    >
      <div class="flex-1">
        {{ translationPrefix + '.label' | finLocalization }}
        @if (isRequired) {
          <span class="flex-1 flex--nogrow"> *</span>
        }
      </div>
    </label>
    <div [class.relative]="theme === DatepickerTheme.WEB_2">
      <input
        class="light-type font-body-medium"
        inputmode="numeric"
        [min]="minDate"
        [max]="maxDate"
        [class.form-field-empty]="!(ctrlField.value || placeHolder)"
        [formControlName]="controlName"
        [matDatepicker]="dp"
        [id]="idOrControlName"
        [placeholder]="placeHolder ? (placeHolder | finLocalization) : null"
        (dateChange)="signalSelection($event)"
        [name]="controlName"
        [ngClass]="{
          'light-type': theme !== DatepickerTheme.WEB_2,
          'medium-type': theme === DatepickerTheme.WEB_2,
          'ps-small': theme === DatepickerTheme.WEB_2,
          'rounded-large': theme === DatepickerTheme.WEB_2,
        }"
        (input)="onDateInput($event)"
      />
      @if (theme !== DatepickerTheme.WEB_2) {
        <span class="divider"></span>
      }
      <div class="absolute datepicker-container">
        <button
          (click)="dp.open()"
          type="button"
          [class.disabled]="ctrlField.disabled"
          [attr.aria-label]="'SERVICE_FORMS.NTServiceForms.helpers.datePicker.openCalendarLabel' | finLocalization"
        >
          <fcom-icon class="icon-medium" [name]="icon" />
        </button>
        <mat-datepicker
          panelClass="service-datepicker elevation-level-1 font-body-medium pr-small white-bg surface-primary regular-type"
          [startView]="startView"
          [startAt]="startAt"
          #dp
        />
      </div>
    </div>
  </div>
  @if ((!ctrlField.invalid || !ctrlField.touched) && helpText) {
    <aside class="font-body-small" data-testid="help-text" [innerHTML]="helpText | finSafe: 'html'"></aside>
  }
  @if (ctrlField.invalid && ctrlField.touched) {
    <div
      class="error-label error-900-text signal-error-notification-border-icon-text font-body-small"
      aria-live="polite"
    >
      @if (ctrlField.errors?.required) {
        <span aria-live="polite" class="required">
          {{ translationPrefix + '.required' | finLocalization }}
        </span>
      }
      @if (ctrlField.errors?.pattern) {
        <span aria-live="polite" class="pattern">
          {{ translationPrefix + '.pattern' | finLocalization }}
        </span>
      }
      @if (ctrlField.errors?.matDatepickerMax) {
        <span aria-live="polite" class="max">
          {{ translationPrefix + '.max' | finLocalization }}
        </span>
      }
      @if (ctrlField.errors?.matDatepickerMin) {
        <span aria-live="polite" class="min">
          {{ translationPrefix + '.min' | finLocalization }}
        </span>
      }
    </div>
  }
</div>
<div aria-live="polite" class="result-helper is-vishidden">
  @if (selectedDay) {
    <span tabindex="-1">
      {{
        translationPrefix + '.selection'
          | finLocalization: { day: selectedDay, month: selectedMonth, year: selectedYear }
      }}
    </span>
  }
</div>
